import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SeccionComplementoComponent } from '../../@secciones/seccion-complemento/seccion-complemento.component';
import { SeccionEstimacionesSiniestroComponent } from '../../@secciones/seccion-estimaciones-siniestro/seccion-estimaciones-siniestro.component';
import { SeccionServiciosComponent } from '../../@secciones/seccion-servicios/seccion-servicios.component';
import { SeccionFotografiasComponent } from '../../@secciones/seccion-fotografias/seccion-fotografias.component';
import { SeccionOcupantesComponent } from '../../@secciones/seccion-ocupantes/seccion-ocupantes.component';
import { SeccionPagosRecuperacionesComponent } from '../../@secciones/seccion-pagos-recuperaciones/seccion-pagos-recuperaciones.component';
import { SeccionVerificaReglasSiniestroComponent } from '../../@secciones/seccion-verifica-reglas-siniestro/seccion-verifica-reglas-siniestro.component';
import { AppState } from 'src/app/@store/app.reducers';
import { Store } from '@ngrx/store';
import { combineLatest, skipWhile, Subscription } from 'rxjs';
import { selectDetalleSiniestroSiniestros, selectObjetoDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { ConsultaSiniestroOutput } from 'src/app/models/complementos-web/complementos-web.model';

import { BotonesIconSeccionComponent } from '../botones-icon-seccion/botones-icon-seccion.component';


export interface BotonDinamico {
  titulo: string;
  icono: string;
  iconoHover?: string;
  iconoSeleccionado?: string;
  permiso: string;
  estatusPermitidos: string[];
  seleccionado?: boolean;
  accion: string;
}

@Component({
    selector: 'app-nav-secciones-complemento',
    templateUrl: './nav-secciones-complemento.component.html',
    styleUrls: ['./nav-secciones-complemento.component.scss'],
    imports: [BotonesIconSeccionComponent]
})
export class NavSeccionesComplementoComponent {

  @Output() recargarDetalleGeneral = new EventEmitter();

  public botones: BotonDinamico[] = [
    {
      titulo: 'Complemento',
      icono: 'assets/img/complemento-web/ico_compl_siniestro.png',
      iconoHover: 'assets/img/complemento-web/ico_compl_siniestro2.png',
      iconoSeleccionado: 'assets/img/complemento-web/ico_compl_siniestro3.png',
      permiso: 'editar_item',
      estatusPermitidos: [],
      seleccionado: false,
      accion: 'abrir-complemento'
    },
    {
      titulo: 'Servicios',
      icono: 'assets/img/complemento-web/ico_servicios.png',
      iconoHover: 'assets/img/complemento-web/ico_servicios2.png',
      iconoSeleccionado: 'assets/img/complemento-web/ico_servicios3.png',
      permiso: 'eliminar_item',
      estatusPermitidos: [],
      seleccionado: false,
      accion: 'abrir-servicios'
    },
    {
      titulo: 'Pagos',
      icono: 'assets/img/complemento-web/ico_pagos.png',
      iconoHover: 'assets/img/complemento-web/ico_pagos2.png',
      iconoSeleccionado: 'assets/img/complemento-web/ico_pagos3.png',
      permiso: 'eliminar_item',
      estatusPermitidos: [],
      seleccionado: false,
      accion: 'abrir-pagos'
    },
    {
      titulo: 'Ocupantes',
      icono: 'assets/img/complemento-web/ico_lesionados.png',
      iconoHover: 'assets/img/complemento-web/ico_lesionados2.png',
      iconoSeleccionado: 'assets/img/complemento-web/ico_lesionados3.png',
      permiso: 'eliminar_item',
      estatusPermitidos: [],
      accion: 'abrir-ocupantes',
      seleccionado: false
    },
    {
      titulo: 'Estimación',
      icono: 'assets/img/complemento-web/ico_estim_coberturas.png',
      iconoHover: 'assets/img/complemento-web/ico_estim_coberturas2.png',
      iconoSeleccionado: 'assets/img/complemento-web/ico_estim_coberturas3.png',
      permiso: 'eliminar_item',
      estatusPermitidos: [],
      accion: 'abrir-estimacion',
      seleccionado: false
    },
    {
      titulo: 'Fotos',
      icono: 'assets/img/complemento-web/ico_fotos.png',
      iconoHover: 'assets/img/complemento-web/ico_fotos2.png',
      iconoSeleccionado: 'assets/img/complemento-web/ico_fotos3.png',
      permiso: 'eliminar_item',
      estatusPermitidos: [],
      accion: 'abrir-fotos',
      seleccionado: false
    },
    {
      titulo: 'Verifica',
      icono: 'assets/img/complemento-web/ico_stop.png',
      iconoHover: 'assets/img/complemento-web/ico_stop2.png',
      iconoSeleccionado: 'assets/img/complemento-web/ico_stop3.png',
      permiso: 'eliminar_item',
      estatusPermitidos: [],
      accion: 'abrir-verifica',
      seleccionado: false
    },
  ];

  public listaObservables = new Subscription();

  public siniestroConsultado: string;
  public detalleSiniestroBase: any;
  public detalleSiniestroCompleto: ConsultaSiniestroOutput;

  constructor(
    private dialog: MatDialog,
    private store: Store<AppState>
  ) {
    this.obtenerRedux();
  }

  obtenerRedux() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectObjetoDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleCompleto, detalleBase]) => {
      this.siniestroConsultado = siniestro;
      this.detalleSiniestroCompleto = detalleCompleto;
    });
    this.listaObservables.add(subsComplemento);
  }

  procesarAccionesNavComplemento(ev: { nombre: string, valor: any }) {
    if (ev.nombre == 'abrir-complemento') {
      this.abrirModalComplemento();
    }
    if (ev.nombre == 'abrir-servicios') {
      this.abrirModalServicios();
    }
    if (ev.nombre == 'abrir-fotos') {
      this.abrirModalFotos();
    }
    if (ev.nombre == 'abrir-verifica') {
      this.abrirModalVerifica();
    }
    if (ev.nombre == 'abrir-estimacion') {
      this.abrirModalEstimaciones();
    }
    if (ev.nombre == 'abrir-pagos') {
      this.abrirModalPagosRecuperaciones();
    }
    if (ev.nombre == 'abrir-ocupantes') {
      this.abrirModalOcupantes();
    }
  }


  abrirModalComplemento() {
    const dialog = this.dialog.open(SeccionComplementoComponent, {
      width: '780px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: { siniestro: this.siniestroConsultado },
    }).beforeClosed().subscribe(data => {
      this.recargarDetalleGeneral.emit();
    });
  }

  abrirModalEstimaciones() {
    const dialog = this.dialog.open(SeccionEstimacionesSiniestroComponent, {
      width: '900px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: {},
    }).beforeClosed().subscribe(data => {

    });
  }

  abrirModalFotos() {
    const dialog = this.dialog.open(SeccionFotografiasComponent, {
      width: '900px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: {},
    }).beforeClosed().subscribe(data => {

    });
  }

  abrirModalServicios() {
    const dialog = this.dialog.open(SeccionServiciosComponent, {
      width: '900px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: {},
    }).beforeClosed().subscribe(data => {
      this.recargarDetalleGeneral.emit();
    });
  }

  abrirModalOcupantes() {
    const dialog = this.dialog.open(SeccionOcupantesComponent, {
      width: '900px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: {},
    }).beforeClosed().subscribe(data => {
      this.recargarDetalleGeneral.emit();
    });
  }

  abrirModalPagosRecuperaciones() {
    const dialog = this.dialog.open(SeccionPagosRecuperacionesComponent, {
      width: '950px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: {},
    }).beforeClosed().subscribe(data => {
      this.recargarDetalleGeneral.emit();
    });
  }

  abrirModalVerifica() {
    const dialog = this.dialog.open(SeccionVerificaReglasSiniestroComponent, {
      width: '900px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: {},
    }).beforeClosed().subscribe(data => {

    });
  }

  procesarTitulo(boton: BotonDinamico) {
    if (['Pagos', 'Recuperaciones'].includes(boton.titulo)) {
      let causa = this.detalleSiniestroCompleto?.Siniestro?.[0]?.causa;
      let serie = this.detalleSiniestroCompleto?.Siniestro?.[0]?.serie;
      let valida = true;

      if ([3, 6].includes(causa)) valida = false;
      else if (serie == null) valida = false;

      if (valida) {
        return this.detalleSiniestroCompleto?.Siniestro?.[0]?.respons_sini == 1 ? 'Pagos' : this.detalleSiniestroCompleto?.Siniestro?.[0]?.respons_sini == 2 ? 'Recuperaciones' : "Pagos/Rec";
      } else {
        return "Pagos/Rec";
      }

    }
    return boton.titulo
  }

}
